import { debounce } from 'lodash';

export function clone(source: any, isDeep = false) {
  const isArray = Array.isArray(source);

  if (!isDeep) {
    if (isArray) return [...source];
    return { ...source };
  }

  const keys = Array.isArray(source) ? null : Object.keys(source);
  const result: any = !keys ? [] : {};
  const length = !keys ? source.length : keys.length;

  for (let i = 0; i < length; i++) {
    const index = !keys ? i : keys[i];
    if (source[index] !== null && typeof source[index] === 'object') {
      result[index] = clone(source[index], isDeep);
    } else {
      result[index] = source[index];
    }
  }

  return result;
}

/**
 * 앞문자만 대문자로 만들기
 * @param str
 * @returns
 */
export function headCase(str: string) {
  const lower = str.toLowerCase();
  return lower
    .split('')
    .map((v, i) => (i === 0 ? v.toUpperCase() : v))
    .join('');
}

/**
 * 숫자 comma 찍기
 * @param value
 * @returns
 */
export function comma(value?: string | number) {
  if (!value) return 0;
  const v = value.toString();
  return v.replace(/\s|,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
 *
 */
export function masking(str = '', length = 1, isCut = false) {
  let cut = str.trimLeft().toString();

  if (isCut) {
    cut = str.slice(0, 5);
  }

  let arrLength = cut.length - length;

  // str 길이가 length 길이 이하인 경우 전부 * 로 만들어 return
  if (arrLength <= 0) {
    return new Array(cut.length).fill('*').join('');
  }

  const mask = new Array(arrLength).fill('*').join('');
  const liveWord = cut.slice(0, length);
  return liveWord + mask;
}

export const submitDebounce = (cb: any) => {
  return debounce(() => {
    cb();
  }, 500);
};
